import React, {useContext} from 'react';
import {Navigate} from 'react-router-dom';
import authContext from "../AuthProvider/authContext";
import cookie from "../utils/cookie";
import AdminDashboard from "../components/AdminDashboard";

const PrivateRoute = ({element: ReactComponent}) => {
    const {state} = useContext(authContext);
    if (!Boolean(state.auth.terms_accepted)) {
        <Navigate to="/tnc-accept"/>
    }
    state.auth.role === 1 && <Navigate to="admin-dashboard"/>

    return cookie.get("jwt") || state.isAuthenticated ? /*(Boolean(state.auth.terms_accepted) ?*/ <ReactComponent/>/* : <Navigate to="/tnc-accept"/>)*/ : <Navigate to="/login"/>;
}

export default PrivateRoute;